module.exports = __webpack_public_path__ + "img/kjjh_gallery3.d3b0f216.jpg";